import type { FaireProductEntity } from "../../entity_types/product";

export const p_9pjchz8tez: FaireProductEntity = {
  token: "p_9pjchz8tez",
  type: "product",
  name: "Sage Spray - Smudging Spray",
  brandToken: "b_4j1osx4h0b",
  brandName: "Shaman's Dawn",
  imageUrl:
    "https://cdn.faire.com/fastly/b21af9d45524746547505687163d057cead5f0ec79a72d42aa19bcf4b8365995.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/819c3ab5d819f8708045fe77a43cc6cd693dc8b9f5d2ae75cd9992c61a96e77d.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Clear your home, work space, or auric field with this blend of white sage and other purifying herbs. Smudge without the smoke- great for work or public spaces. \n\nMade with:\n\nWhite Sage, Cedar, and Rosemary \n\nUse for:\n\nWhite Sage and Cedar have long been used by the people of North America during smoke or smudging ceremonies to purify the mind, heart, body, and soul. This spray brings forth the energies of these sacred plants without having to use smoke. Spray in an area to purify energy. Fan the mist over yourself to cleanse your personal energy field.\n\nHand Made - No Animal Products - No Animal Testing\n\nAll Natural and Made with Essential Oils\n\nShamanically blessed in ceremony\n\nThe Shamans Dawn line of energy clearing sprays is hand blended and shamanically blessed by Adam Kane with healing energy and intention. Each spray is a blend of herbs that Adam was guided to use by the healing spirits. The sprays draw upon the powers and energies of the plant spirits within them to clear and balance the energy of a space or person's energy field to facilitate peace and healing.\n\nEach cobalt glass bottle is 4oz\n",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:34.714Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
